import { Alert, Button, Col, Form, Input, message, Row } from 'antd';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import { APIResponseCode, Constants } from 'common/constants';
import { Link } from 'react-router-dom';
import { AccountSelector } from '../store/AccountSelector';
import { PATHS } from '@routing/routes';
import { ResetNewPasswordByOTP } from '../business/AccountBusiness';

export const PasswordResetOTP = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const accountState = useSelector(AccountSelector);

  const onFinish = async (values: any) => {
    if (accountState.IsValidOTP && accountState.ResetPasswordResponseViewModel) {
      const response = await dispatch(
        ResetNewPasswordByOTP({
          Id: accountState.ResetPasswordResponseViewModel.Id,
          NewPassword: values.NewPassword,
        })
      );
      if (response.toString() === APIResponseCode.SUCCESS) {
        // message.success('Password reset successful');
        history.push(PATHS.ResetPasswordConfirmation.path);
      } else {
        message.error('Unable to reset password. Please try again later.');
        history.push(PATHS.Login.path);
      }
    } else {
      history.push(PATHS.Login.path);
    }
  };

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.reject('This field is required');
    }

    if (!Constants.PASSWORD_REGEX.test(value)) {
      const informationMessage = (
        <div>
          <p className="pHeader">Passwords should be a minimum of 8 characters long and contain a mix of:</p>
          <ul className="pBottom">
            <li>numbers</li>
            <li>uppercase and lowercase letters</li>
            <li>special characters {Constants.ERROR_PASSWORD_ssFORMAT}</li>
          </ul>
        </div>
      );
      return Promise.reject(<Alert description={informationMessage} className="mb-10" type="error" />);
    }

    return Promise.resolve();
  };
  return (
    <div className="App">
      <Form name="senderForm" onFinish={onFinish} layout="vertical">
        <Row justify="center" align="middle">
          <h4>Reset password</h4>
        </Row>
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={12} lg={8} xl={8}>
            <Form.Item label="New password" name="NewPassword" rules={[{ validator: validatePassword }]}>
              <Input.Password
                type="password"
                size="large"
                maxLength={20}
                onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
              />
            </Form.Item>

            <Button className="nextSenderBtn full-width" size="large" type="primary" htmlType="submit">
              Save new password
            </Button>
          </Col>
        </Row>
        <br />
        <Row justify="center">
          <Link to={PATHS.Login.path} className="normal-font center">
            Back to Log in
          </Link>
        </Row>
      </Form>
    </div>
  );
};
